import React from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import WhatWeOffer from "../components/WhatWeOffer";
import FeatureCards from "../components/FeatureCards";
import HowItWorks from "../components/HowItWorks";
import CTABanner from "../components/CTABanner";
import HomeFAQ from "../components/HomeFAQ";
import ContactSection from "../components/ContactSection";
import PartnersSection from "../components/PartnersSection";
import ProviderAccessCTA from "../components/ProviderAccessCTA";
import AffiliateProgramCTA from "../components/AffiliateProgramCTA";
import Footer from "../components/Footer";
import JsonLd from "../components/JsonLd";
import { usePageSEO } from "../hooks/usePageSEO";

// FAQPage schema injected ONLY on /. Previously this lived in index.html
// (rendered on every URL), which produced ~18 invalid FAQ entries in GSC
// for pages that don't actually display these questions.
const HOMEPAGE_FAQ_JSONLD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "@id": "https://www.peptidesformedspas.org/#faq",
  mainEntity: [
    {
      "@type": "Question",
      name: "What are peptides used in med spa and aesthetic research?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Peptides are short chains of amino acids (2-50 amino acids) that act as signaling molecules. In med spa and aesthetic research, peptides like GHK-Cu, glutathione, and NAD+ are widely studied for roles in collagen biology, oxidative stress, and cellular metabolism. Other categories include weight-loss / metabolism peptides (5-Amino-1MQ), recovery peptides (BPC-157, TB-500, Pentadeca Arginate), hormone & longevity peptides (Sermorelin, MOTS-c), and sexual-wellness peptides (PT-141).",
      },
    },
    {
      "@type": "Question",
      name: "Are research peptides legal to buy?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "In the United States, most peptides are classified as research chemicals and are legal to purchase for laboratory research purposes. They are NOT approved for human or animal use without specific FDA approval. Sale for human consumption is illegal without FDA approval. Legal status varies by country and jurisdiction.",
      },
    },
    {
      "@type": "Question",
      name: "Is PeptidesForMedSpas a medical provider or pharmacy?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "No. PeptidesForMedSpas is an educational storefront focused on research peptides studied in med spa, aesthetic, and wellness contexts. We do not provide medical advice, diagnoses, or treatment recommendations, and we are not a pharmacy. We provide educational content about peptide chemistry and research, and encourage consulting licensed healthcare professionals for any medical question.",
      },
    },
    {
      "@type": "Question",
      name: "Are your products FDA approved?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Research peptides on this site are classified as research chemicals for laboratory use only. They are not FDA-approved drugs. These statements have not been evaluated by the FDA. Not intended to diagnose, treat, cure, or prevent any disease.",
      },
    },
  ],
};

const HomePage = () => {
  usePageSEO();
  return (
    <div className="min-h-screen bg-[#fffaf5]">
      <Header />
      <JsonLd id="home-faq-jsonld" data={HOMEPAGE_FAQ_JSONLD} />
      <HeroSection />
      <WhatWeOffer />
      <FeatureCards />
      <HowItWorks />
      <CTABanner />
      <ProviderAccessCTA />
      <PartnersSection />
      <AffiliateProgramCTA />
      <HomeFAQ />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;
